import React from 'react';
import { company } from '../data/company';
import { SectionHeading } from './SectionHeading';
export function OperatingRegions() {
  return <section className="border-y border-hair bg-panel2/40 py-20" data-id="element-163" data-mp="1hg71vb4dgaqt">
      <div className="mx-auto max-w-shell px-6" data-id="element-164" data-mp="1dgy8469c0cv9">
        <SectionHeading eyebrow="Where we trade" title="Democratic Republic of Congo, Zambia and across East Africa" intro="Our sourcing and trading footprint runs from the Katangan and Zambian Copperbelt through the East African corridor, with export cargo moving to buyers worldwide." data-id="element-165" data-mp="1dhrhlezodgh3" />

        <div className="mt-12 grid gap-6 lg:grid-cols-2" data-id="element-166" data-mp="1we951k7hqu7j">
          {company.primaryCountries.map(country => <article key={country.name} className="flex gap-5 border border-hair bg-ink p-6" data-id="element-167" data-mp="1rghbklr77018">
              <img src={country.flag} alt={`Flag of ${country.name}`} className="h-14 w-auto shrink-0 border border-hair object-cover" loading="lazy" data-id="element-168" data-mp="2ovbq4uhely3d" />
              <div data-id="element-169" data-mp="1pz9aefrxjff2">
                <h3 className="font-display text-2xl leading-snug text-bone" data-id="element-170" data-mp="1q0sp41xxtieq">{country.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-171" data-mp="1uzwyaskv3g52">{country.note}</p>
              </div>
            </article>)}
        </div>

        <div className="mt-10 border-t border-hair pt-8" data-id="element-172" data-mp="1l6xysfntu56o">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted" data-id="element-173" data-mp="17882h28u09jd">
            East African trading &amp; transit network
          </p>
          <ul className="mt-5 flex flex-wrap gap-3" data-id="element-174" data-mp="1c849zbgqmj3o">
            {company.eastAfrica.map(country => <li key={country.name} className="flex items-center gap-2.5 border border-hair bg-ink px-3.5 py-2 text-sm text-bone/90" data-id="element-175" data-mp="y94izx5r5s4c">
                <img src={country.flag} alt={`Flag of ${country.name}`} className="h-4 w-auto object-cover" loading="lazy" data-id="element-176" data-mp="2smw0tjy8jiav" />
                {country.name}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}